import { addAllToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import type {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import type {
  ThreadPinToGroupFeedFulfilledAction,
  ThreadUnpinFromGroupFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import type {
  PublishGroupMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
} from '../../../domains/publishers/actions.types';
import type { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import type { ThreadsPinnedToFeeds } from '../types';
export type ThreadsPinnedToGroupFeedsAction =
  | DeleteMessageFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | PublishGroupMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToGroupFeedFulfilledAction
  | ThreadUnpinFromGroupFeedFulfilledAction;
const initialState: ThreadsPinnedToFeeds = {};
const prependNewlyPublishedThreadToPins = (
  state: ThreadsPinnedToFeeds,
  { threadId, groupId, isDraft, isAutoPinnedThread }: PublishGroupMessageFulfilledAction['payload']
) => {
  if (isDraft || !isAutoPinnedThread) {
    return state;
  }
  const existingGroupPinnedThreads = state[groupId]?.threadIds || [];
  const updatedState = {
    ...state,
    [groupId]: {
      ...state[groupId],
      threadIds: [threadId, ...existingGroupPinnedThreads],
    },
  };

  return updatedState;
};
const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToGroupFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'THREAD.PIN_TO_GROUP_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'THREAD.UNPIN_FROM_GROUP_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToGroupFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === 'THREAD_REMOVED'
      );
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return prependNewlyPublishedThreadToPins(state, action.payload);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return prependNewlyPublishedThreadToPins(state, action.payload);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return prependNewlyPublishedThreadToPins(state, action.payload);
    default:
      return state;
  }
};
export default reducer;
